// extracted by mini-css-extract-plugin
export default {"cardWrapper":"PopUpCard_cardWrapper__MvSjl","wrapper":"PopUpCard_wrapper__zYyNL","exit":"PopUpCard_exit__2Rpib","exitIcon":"PopUpCard_exitIcon__GyHsi"};